import React from 'react';
import IcoEdition from "../assets/solution_icon/edition.svg";
import IcoConsulting from "../assets/solution_icon/consulting.svg";
import IcoOutils from "../assets/solution_icon/outils.svg"
import IcoRecherche from "../assets/solution_icon/recherche.svg";
import "./style/solution.css"
import ReactSVG from 'react-svg'



class Solutions extends React.Component {

  render() {
    return (
      <div className="backgroundSolution">
        <div className="flex-container-solution">
          <div style={{ width: "35%" }}>

            <div style={{ display: "flex",width: "60%" }}>
              <div style={{alignSelf: "center"}}>
                <ReactSVG style={{ width: "40px" }} src={IcoEdition} />
              </div>
              <div style={{marginLeft: "12%"}}>
                <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald",fontSize: "18px",textAlign:"left",width:"82px" }}>ÉDITION DE SOLUTION</h3>
              </div>
            </div>
            <div>
              <p style={{color:"#58585b",fontFamily:"Open Sans",fontWeight:"400",textAlign: "justify",fontSize: "15px",lineHeight: "25px"}}>
                Nous concevons des solutions innovantes spécifiques aux besoins de nos clients entreprises,
                    quel que soit le secteur d’activité.
              </p>
            </div>
          </div>


          <div style={{ width: "35%"}}>
            <div >
              <div style={{ display: "flex",width: "100%" }}>
                <div style={{alignSelf: "center"}}>
                  <ReactSVG style={{ width: "40px" }} src={IcoConsulting} />
                </div>
                <div style={{marginLeft: "12%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald",fontSize: "18px",textAlign:"left",width:"177px" }}>CONSULTING & BUSINESS INTELLIGENCE</h3>
                </div>
              </div>
              <div>
                <p style={{color:"#58585b",fontFamily:"Open Sans",fontWeight:"400",textAlign: "justify",fontSize: "15px",lineHeight: "25px"}}>
                  Nous proposons un accompagnement personnalisé
                  pour les projets stratégiques et novateurs de nos clients.
                </p>
              </div>
            </div>
          </div>


          <div style={{ width: "35%" }}>
          <div >
              <div style={{ display: "flex",width: "60%" }}>
                <div style={{alignSelf: "center"}}>
                  <ReactSVG style={{ width: "40px" }} src={IcoOutils} />
                </div>
                <div style={{marginLeft: "12%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald",fontSize: "18px",textAlign:"left",width:"0px" }}>OUTILS DIGITAUX</h3>
                </div>
              </div>
              <div>
                <p style={{color:"#58585b",fontFamily:"Open Sans",fontWeight:"400",textAlign: "justify",fontSize: "15px",lineHeight: "25px"}}>
                Nous concevons des outils digitaux de visibilité qui permettent 
                de rapidement développer un business et fidéliser les clients. 
                </p>
              </div>
            </div>
          </div>





        <div style={{ width: "35%"}}>
          <div >
              <div style={{ display: "flex",width: "75%" }}>
                <div style={{alignSelf: "center"}}>
                  <ReactSVG style={{ width: "40px" }} src={IcoRecherche} />
                </div>
                <div style={{marginLeft: "12%"}}>
                  <h3 style={{ color: "#3d3d3d", fontFamily: "Oswald",fontSize: "18px" ,textAlign:"left",width:"103px"}}>RECHERCHE & DÉVELOPPEMENT</h3>
                </div>
              </div>
              <div>
                <p style={{color:"#58585b",fontFamily:"Open Sans",fontWeight:"400",textAlign: "justify",fontSize: "15px",lineHeight: "25px"}}>
                Nous aidons les entreprises à définir leurs stratégies d’innovation, à monter, 
                piloter et coordonner leurs différents projets R&D.  
                </p>
              </div>
            </div>
          </div>


        </div>
      </div>
    );
  }
}

Solutions.propTypes = {
 // classes: PropTypes.object.isRequired,
};

export default Solutions;



// WEBPACK FOOTER //
// ./src/home/solutions.js